import { titleCardEditSchema } from "@pimo/pimo-components";
import {
  PMTitleCard,
  PMTitleCardProps,
} from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { theme } from "../../../theme";
import { formatDate } from "../../../utils/format-date";
import { DashboardCardContext } from "../context";

export function addTitleCard(ctx: DashboardCardContext) {
  const { view, getCardCopy } = ctx;

  const titleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "titleComponent",
      title: "",
      description: "",
      labels: ["title", "dashboardTitle"],
      editSchema: titleCardEditSchema,
    },
  });

  titleComponent.mapLayoutProps(({ language }) => ({
    componentId: "titleComponent",
    description: getCardCopy(language, "dashboardTitle").description,
    title: getCardCopy(language, "dashboardTitle").title,
    labels: ["title", "dashboardTitle"],
    editSchema: titleCardEditSchema,
  }));

  titleComponent.mapState(
    ({ dashboardComponentValues, settings, language, dashboard }) => {
      return {
        title:
          (dashboardComponentValues?.["titleComponent"] as PMTitleCardProps)
            ?.title ??
          `${getLocalizedMessage(language, "dashboard") || "Dashboard"} ${
            settings?.configuration?.programName
              ? `- ${settings?.configuration?.programName}`
              : ""
          }`,
        badgeConfigs: dashboard?._calculated.lastReportingEndDate
          ? [
              {
                label: `${
                  getLocalizedMessage(language, "AsOf") || "As of"
                }: ${formatDate(dashboard?._calculated.lastReportingEndDate, language)}`,
                backgroundColor: theme.palette.secondary.light,
                color: theme.palette.primary.main,
              },
            ]
          : [],
      };
    }
  );
}
